import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "whats-unsupported-in-uxp"
    }}>{`What's Unsupported in UXP`}</h1>
    <p>{`Since UXP does not include a full-blown web browser with all the bells and whistles, there are a number of HTML and CSS features that are not currently implemented. Some of these are under development, while others (e.g., iFrames) may never appear.`}</p>
    <p>{`Bookmark this page so you can see after each Photoshop release if anything has changed with the list below.`}</p>
    <h2 {...{
      "id": "web-features"
    }}>{`Web features`}</h2>
    <ul>
      <li parentName="ul">{`Drag and drop (coming soon)`}</li>
      <li parentName="ul">{`iFrames`}</li>
      <li parentName="ul">{`HTML5 Canvas`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`window.location`}</inlineCode>{` ( for loading a webpage inside a plugin)`}</li>
      <li parentName="ul">{`data attributes and `}<inlineCode parentName="li">{`font-face`}</inlineCode></li>
      <li parentName="ul">{`CSS `}<inlineCode parentName="li">{`float`}</inlineCode>{` (use `}<inlineCode parentName="li">{`flexbox`}</inlineCode>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "javascript-frameworks-and-libraries"
    }}>{`JavaScript Frameworks and Libraries`}</h2>
    <ul>
      <li parentName="ul">{`jQuery`}</li>
      <li parentName="ul">{`Vue.js (although some people have reported success)`}</li>
    </ul>
    <h2 {...{
      "id": "javascript-workarounds"
    }}>{`JavaScript workarounds`}</h2>
    <p><inlineCode parentName="p">{`window.event.cancelBubble = true`}</inlineCode>{` is not supported. Instead, use `}<inlineCode parentName="p">{`event.stopPropagation()`}</inlineCode></p>
    <p><inlineCode parentName="p">{`getElementsByClassName(something)`}</inlineCode>{` is not supported. Instead, use `}<inlineCode parentName="p">{`document.querySelectorAll("something")`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      